// fits up to "we found 99 clips"
export const SUGGESTED_CLIPS_TRIGGER_WIDTH = '211px';
